import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router";
import "moment/locale/th";
import PageHeaderV2 from "../../../pageheaderV2/PageHeaderV2";
import TableSearchV1 from "../../../tableV1/tableSearchV1";
import ModalUploadFileV3 from "../../../material/modal/ModalUploadFileV3";
import * as adminApi from "../../../../service/adminApi";
import { CurrentUserContext } from "../../../../App";
import { FaCircle, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import format from "date-fns/format";

const RelatedDocument = () => {
  const { setIsMessage } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [documentList, setDocumentList] = useState([]);
  const [page, setPage] = useState(1);
  const [amount, setAmount] = useState(0);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);
  const [currentDocument, setCurrentDocument] = useState(null);
  const [sortBy, setSortBy] = useState({ id: "", desc: false });

  const [filters, setFilters] = useState({
    document_name: "",
    "owner.fname": "",
    "create_date.date": "",
    "update_date.date": "",
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    fetchDocumentList();
  }, [page, filters, sortBy]);

  const fetchDocumentList = async () => {
    setLoading(true);
    try {
      const res = await adminApi.getDocument(
        page,
        10,
        filters.document_name,
        filters["owner.fname"],
        formatDate(filters["create_date.date"]),
        formatDate(filters["update_date.date"]),
        sortBy.id,
        sortBy.id ? (sortBy.desc ? "desc" : "asc") : "",
      );
      if (res?.data?.code === 200) {
        setDocumentList(res.data.document_list);
        setAmount(res.data.amount);
        setMaxPage(Math.ceil(res.data.amount / 10));
      } else if (res?.data?.code === 403) {
        navigate("/redirect");
      } else {
        setIsMessage({
          type: "warning",
          data: res?.data?.message_th || res?.data?.message,
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddDocument = async (event) => {
    const formData = new FormData();
    formData.append("file", event.file);
    formData.append("file_name", event.inputValue);

    setLoading(true);
    try {
      const res = await adminApi.addDocument(formData);
      if (res?.data?.code === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        setOpenModalUploadFile(false);
        fetchDocumentList();
      } else {
        setIsMessage({
          type: "warning",
          data: res?.data?.message_th || res?.data?.message,
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveDocument = async (item) => {
    if (!window.confirm(`คุณต้องการลบ ${item.document_name} ใช่หรือไม่`))
      return;

    setLoading(true);
    try {
      const res = await adminApi.removeDocument(item.document_id);
      if (res?.data?.code === 200) {
        fetchDocumentList();
      } else {
        setIsMessage({
          type: "warning",
          data: res?.data?.message_th || res?.data?.message,
        });
      }
    } catch (error) {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEditDocument = (item) => {
    setCurrentDocument({
      document_id: item.document_id,
      document_name: item.document_name,
      fileUrl: item.document_file,
    });
    setOpenModalUploadFile(true);
  };

  const handleSortChange = (id, desc) => {
    setPage(1);
    setSortBy({ id, desc });
  };

  const formatDate = (date) => {
    if (!date) return "";
    return format(date, "yyyy-MM-dd");
  };

  const formatDateThai = (date) => {
    const monthsThai = [
      "ม.ค.",
      "ก.พ.",
      "มี.ค.",
      "เม.ย.",
      "พ.ค.",
      "มิ.ย.",
      "ก.ค.",
      "ส.ค.",
      "ก.ย.",
      "ต.ค.",
      "พ.ย.",
      "ธ.ค.",
    ];
    const [year, month, day] = date.split("-");
    const formattedDate = `${parseInt(day)} ${
      monthsThai[parseInt(month) - 1]
    } ${year}`;
    return formattedDate;
  };

  const columns = [
    {
      Header: "No.",
      accessor: "id",
      Filter: "#",
    },
    {
      Header: "ชื่อหัวข้อ",
      accessor: "document_name",
      Filter: "text",
    },
    {
      Header: "ผู้สร้าง",
      accessor: "owner.fname",
      // Cell: ({ row }) => {
      //   const name = `${row.original.owner.fname} ${row.original.owner.lname}`;
      //   return <div dangerouslySetInnerHTML={{ __html: name }} />;
      // },
      Filter: "text",
    },
    {
      Header: "วันที่สร้าง",
      accessor: "create_date.date",
      Cell: ({ row }) => {
        const createdDate =
          row.original.create_date && row.original.create_date.date
            ? row.original.create_date.date
            : null;
        return createdDate ? formatDateThai(createdDate) : "";
      },
      Filter: "date",
    },
    {
      Header: "วันที่แก้ไข",
      accessor: "update_date.date",
      Cell: ({ row }) => {
        const updatedDate =
          row.original.update_date && row.original.update_date.date
            ? row.original.update_date.date
            : null;
        return updatedDate ? formatDateThai(updatedDate) : "-";
      },
      Filter: "date",
    },
    {
      Header: "#",
      disableSortBy: true,
      accessor: "actions",
      Cell: ({ row }) => {
        const i = row.original;

        return (
          <div className="flex flex-row justify-center items-center gap-[6px]">
            <div
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#DFEEFA 0% 0% no-repeat padding-box" }}
              onClick={() =>
                navigate(
                  `/admin/management/document/view-document/${i["document_id"]}`,
                  {
                    state: {
                      type: "document",
                      id: i["document_id"],
                      title: i["document_name"],
                      file: i["document_file"],
                      fname: i["owner"]["fname"],
                      lname: i["owner"]["lname"],
                      create_date: i["create_date"]["date"],
                      update_date: i["create_date"]["date"],
                    },
                  },
                )
              }
            >
              <FaEye className="text-[#46A8F4] h-[14px]" />
            </div>
            <button
              className="flex justify-center items-center h-[30px] p-2 rounded-[5px] cursor-pointer"
              style={{ background: "#FCD8DB 0% 0% no-repeat padding-box" }}
              onClick={() => handleRemoveDocument(i)}
            >
              <FaTrash className="text-[#D32736] h-[14px]" />
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <div className="min-w-[708px] overflow-x-auto">
      <ModalUploadFileV3
        show={openModalUploadFile}
        title="อัพโหลดไฟล์เอกสาร"
        placeholder="ชื่อเอกสาร"
        titlename="อัพโหลดไฟล์เอกสาร"
        onSubmit={handleAddDocument}
        initialData={currentDocument}
        onClose={() => setOpenModalUploadFile(false)}
      />
      <PageHeaderV2 titlename="เอกสารที่เกี่ยวข้อง" />
      <TableSearchV1
        columns={columns}
        data={documentList}
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        total={amount}
        page={page}
        maxPage={maxPage}
        setPage={setPage}
        sortBy={sortBy}
        onSortChange={handleSortChange}
        addData={{
          name: "เพิ่มไฟล์",
          state: () => {
            setOpenModalUploadFile(true);
            setCurrentDocument(null);
          },
        }}
        noDataComponent={<div className="w-full text-left">ไม่พบข้อมูล</div>}
      />
    </div>
  );
};

export default RelatedDocument;
